module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"pageTitle":"Traductions","textNoTranslation":"Ajoutez une traduction pour cette catégorie avant de la sauvegarder","btnAddTranslation":"Ajouter une traduction"},"en":{"pageTitle":"Translations","textNoTranslation":"Add a translation before saving","btnAddTranslation":"Add a translation"}}')
  delete Component.options._Ctor
}
